import styled from "styled-components";

// A single 0–100 stat bar (satiety / hygiene / happiness). Each meter is colored
// by type (caller passes the color + glyph) with a soft glow on the fill.
const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Head = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const Label = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 11px;
  letter-spacing: 0.03em;
  text-transform: lowercase;
  color: ${({ theme }) => theme.color.textDim};
`;

const Glyph = styled.span<{ $color: string }>`
  color: ${({ $color }) => $color};
  font-size: 12px;
`;

const Value = styled.span`
  font-family: ${({ theme }) => theme.font.mono};
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.text};
`;

const Track = styled.div`
  height: 6px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: rgba(255, 255, 255, 0.06);
  overflow: hidden;
`;

const Fill = styled.div<{ $pct: number; $color: string }>`
  height: 100%;
  width: ${({ $pct }) => $pct}%;
  border-radius: inherit;
  background: ${({ $color }) => $color};
  box-shadow: 0 0 12px ${({ $color }) => `${$color}55`};
  transition: width 0.3s ease;
`;

export function Meter({
  label,
  value,
  color,
  icon,
}: {
  label: string;
  value: number;
  color: string;
  icon?: string;
}) {
  const pct = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <Row>
      <Head>
        <Label>
          {icon && <Glyph $color={color}>{icon}</Glyph>}
          {label}
        </Label>
        <Value>{pct}</Value>
      </Head>
      <Track>
        <Fill $pct={pct} $color={color} />
      </Track>
    </Row>
  );
}
